export enum DoctorMode {
    DOCTOR = '0',
    ANAMNESIS = '1'
}